"use strict";
/**
 * Alert Component Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var Alert_1 = require("./Alert");
Object.defineProperty(exports, "Alert", { enumerable: true, get: function () { return Alert_1.Alert; } });
